module.exports = __webpack_public_path__ + "img/bs.b8d3e864.png";